import { Component, Inject, OnInit } from '@angular/core';
import { MeasureService } from '../measure.service';
import { map, switchMap } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-modal-measure-report',
  templateUrl: './modal-measure-report.component.html',
  styleUrls: ['./modal-measure-report.component.scss']
})
export class ModalMeasureReportComponent implements OnInit {

  modalData: any;
  isLoading: boolean;
  report;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalMeasureReportComponent>,
    private measureService: MeasureService
  ) {
    this.modalData = data;
  }

  ngOnInit(): void {
    console.log(this.modalData);
    this.report = this.modalData.report[0];
  }

  preliminaryReport(type) {
    // // console.log(type);
    const response = {
      status: true,
      report_type: type,
      paid: 'free',
      view_status: this.modalData.view_status
    }
    this.dialogRef.close(response);
  }

  indeptReport(type) {
    // // console.log(type);
    const response = {
      status: true,
      report_type: type,
      paid: 'notfree',
      view_status: this.modalData.view_status
    }
    this.dialogRef.close(response);
  }

  paid() {
    window.open('/payment?id=' + this.report.REPORT_ID + '&type=' + 'report', '_self')
  }

  closeModal() {
    const response = {
      status: false,
    }

    this.dialogRef.close(response);
  }

}
